import { render } from "./BoatCard.vue?vue&type=template&id=5e6342ff"
import script from "./BoatCard.vue?vue&type=script&lang=js"
export * from "./BoatCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\opyon\\source\\repos\\Microsites\\Dealer Microsites\\src\\DealerMicrosites.UI\\client-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__